import React from 'react';
import { Spin } from 'antd';

export default ({ tip }) => (
  <div className="container-height" style={{ paddingTop: 24, textAlign: 'center' }}>
    <Spin spinning size="large" tip={tip} style={{ color: 'rgba(0, 0, 0, 0.65)' }} />
  </div>
);
